import * as React from "react";
import { useListItem } from "@floating-ui/react";
import classnames from "classnames";
import { useDropdownContext } from "../../../../../context/ButtonDropdown/context/ButtonDropdownContext.js";
const ButtonDropdownOption = ({
  className,
  children,
  value,
  isDisabled,
  "aria-label": ariaLabel
}) => {
  const {
    activeIndex,
    selectedIndex,
    floatingProps: { getItemProps },
    handleSelect
  } = useDropdownContext();
  const { ref, index } = useListItem();
  const isActive = activeIndex === index;
  const isSelected = selectedIndex === index;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      ref,
      role: "option",
      type: "button",
      className: classnames("button-dropdown__option", className, {
        "button-dropdown__option--disabled": isDisabled
      }),
      "data-value": value,
      disabled: isDisabled,
      "aria-label": ariaLabel,
      "aria-selected": isActive && isSelected,
      tabIndex: isActive && !isDisabled ? 0 : -1,
      ...getItemProps({
        onClick: () => handleSelect(index, value)
      })
    },
    children
  );
};
export {
  ButtonDropdownOption
};
//# sourceMappingURL=ButtonDropdownOption.js.map
